<template>
  <div class="rating-stars-canvas">
    <div class="inactive">
      <i class="icon"><icon-star /></i>
      <i class="icon"><icon-star /></i>
      <i class="icon"><icon-star /></i>
      <i class="icon"><icon-star /></i>
      <i class="icon"><icon-star /></i>
    </div>
    <div
      class="active"
      :style="'width:'+percent+'%'"
    >
      <div class="active-items">
        <i class="icon"><icon-star-alternative /></i>
        <i class="icon"><icon-star-alternative /></i>
        <i class="icon"><icon-star-alternative /></i>
        <i class="icon"><icon-star-alternative /></i>
        <i class="icon"><icon-star-alternative /></i>
      </div>
    </div>
  </div>
</template>
<script>

import IconStar from 'ICON:IconStar';
import IconStarAlternative from 'ICON:IconStarAlternative';

export default {
  name: 'RatingStars',
  components: {
    IconStar,
    IconStarAlternative,
  },
  props: {
    percent: {
      type: Number,
      default: 0,
    },
  },
  serverCacheKey: (props) => `RatingStars${props.percent}`,
};
</script>
